
<template>
  <div>
    <v-row  class="justify-space-around align-bottom text-start mb-5 flex-wrap">
      <v-col cols="6" md="6" lg="6" class="pa-6 pr-0">
        <v-card class="elevation-1 d-flex flex-column" height="100%">
          <v-card-title class="title text-start primary darken-2 white--text py-1"><span class="text-h6">Total em faturas</span>
            <v-spacer></v-spacer>
            <v-icon class="white--text">mdi-cash</v-icon>
          </v-card-title>
          <v-card-text class="mt-0 d-flex align-center flex-column flex-fill justify-center py-0 mt-0 ">
            <div class="text-xs-left py-2">
              <!-- <span>Pago:</span> -->
              <span class="font-weight-bold ml-1 black--text text-h4 text-subtitle-1">
                {{ loading_counters ? 'Carregando...' : Number(total_ammount_sum).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" md="6" lg="6" class="pa-6 pl-3">
        <v-card class="elevation-1 d-flex flex-column" height="100%">
          <v-card-title class="title text-start primary darken-2 white--text py-1"><span class="text-h6">Total em aberto:</span>
            <v-spacer></v-spacer>
            <v-icon class="white--text">mdi-calendar</v-icon>
          </v-card-title>
          <v-card-text class="mt-0 d-flex align-center flex-column flex-fill justify-center py-0 mt-0 ">
            <div class="text-xs-left py-2">
              <!-- <span>Numero total de pedidos:</span> -->
              <span class="font-weight-bold ml-1 black--text text-subtitle-1">
                {{ loading_counters ? 'Carregando...' : Number(total_open_and_overdue).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="d-flex pb-0">
        <v-btn @click="filterByStatus('available')" small :class="['ma-1 ml-3', available ? 'success' : 'grey white--text']"  :disabled="loading"><v-icon left>{{ available ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon> Disponível</v-btn>
        <v-btn @click="filterByStatus('waiting_payment')" small :class="['ma-1', waiting_payment ? 'success' : 'grey white--text']" :disabled="loading"><v-icon left>{{ waiting_payment ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon> Aguardando pagamento</v-btn>
        <v-btn @click="filterByStatus('done')" small :class="['ma-1', done ? 'success' : 'grey white--text']" :disabled="loading"><v-icon left>{{ done ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon> Finalizados</v-btn>
        <v-btn @click="filterByStatus('protested')" small :class="['ma-1', protested ? 'success' : 'grey white--text']" :disabled="loading"><v-icon left>{{ protested ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon> Protesto</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="shortView()" small class="primary mr-3"><v-icon left >{{ with_comment ? 'mdi-chat-remove' : 'mdi-chat' }}</v-icon> {{ with_comment ? 'Ocultar comentário' : 'Exibir comentário' }}</v-btn>  
        <BtnCreateDataExport 
          class="pr-3"
          light-toolbar
          as-button
          api_model="VrtTransaction" 
          action="VrtTransactionHistoric"
          :filters="filters"
          :hide_list="['pdf']"
          small
          :file_name="`${'Faturas - ' + client_name}`"
        ></BtnCreateDataExport>
      </v-col>
    </v-row>

    <v-data-table 
      :loading="loading || loading_depot" 
      :server-items-length="total_items_count" 
      :headers="headers" 
      :items="client_vrt_transactions" 
      :options="{itemsPerPage: -1}" 
      :footer-props="{itemsPerPageOptions: [10, 30, 50, 100]}"
      :options.sync="pagination"
      mobile-breakpoint="1"
      class="mb-3"
    >
      <template v-slot:item.order_id="{item}">
        <div class="d-flex align-center">
          {{ item?.order_id || item?.external_order_id }}
          <v-btn small icon @click="goToOrder(item)" v-if="item?.order_id || item?.external_order_id">
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.solution="{item}">
        {{ item.solution == 'wholesale' ? 'GC' : depots_mapped[item.place_id] }}
      </template>

      <template v-slot:item.DateExpired="{item}">
        {{ $moment(item.DateExpired).format('DD/MM/YYYY') }}
      </template>

      <template v-slot:item.payment_ammount="{item}">
        <div class="d-flex">
          <span class="text-no-wrap success--text text--darken-2">
            {{Number(item.ammount_payed).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </span>
          <span class="mx-1 text-no-wrap"> / </span> 
          <span class="text-no-wrap black--text text--darken-2">
            {{Number(item.ammount).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </span>
        </div>
      </template>

      <template v-slot:item.payment_description="{item}">
        {{ !!item.payment_description ? item.payment_description : '-' }}
      </template>

      <template v-slot:item.rest="{item}">
        <span class="text-no-wrap">
          <b class="error--text text--darken-1">
            {{( Number(item.ammount) - Number(item.ammount_payed) ).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </b>
        </span>
      </template>

      <template v-slot:item.processing="{item}">
        <v-chip 
          small 
          :color="item.pay_status == 'available' ? 'success' : item.pay_status == 'done' ? 'primary' : 'orange'" 
          text-color="white"
        >{{ pay_status_map[item.pay_status] }}</v-chip>
      </template>

      <template v-slot:item.actions="{item}">
        <v-btn 
          small 
          color="primary" 
          text-color="white"
          icon
          @click="openVrtPaymentsAssignedDialog(item)"
        ><v-icon>mdi-information</v-icon></v-btn>

        <v-btn 
          small 
          color="primary" 
          text-color="white"
          icon
          @click="createProtest(item)"
          :disabled="['waiting_payment', 'available', 'processing', 'done', 'error'].includes(item.pay_status) && !canCreate"
        ><v-icon>mdi-gavel</v-icon></v-btn>

      </template>

    </v-data-table>
    <router-view></router-view>
    <AssignedVrtPaymentDialog v-if="dialog" :selected_item="selected_item" @closeDialog="handleCloseDialog"></AssignedVrtPaymentDialog>
  </div>
</template>

<script>
import Api from '@/api/index';
import cimentao_links from "@/mixins/cimentao_links";

export default {
  name: 'ClientProfileAllVrtTransactions',
  mixins: [ cimentao_links ],
  components: {
    AssignedVrtPaymentDialog: () => import('./AssignedVrtPaymentDialog'),
    BtnCreateDataExport: () => import("@/components/data_export/BtnCreateDataExport.vue"),
  },
  props: {
    client_name: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      pay_status_map:{
        available: 'Disponível', 
        waiting_payment: 'Aguardando pagamento', 
        processing: 'Processando', 
        done: 'Finalizado', 
        protested: 'Protestado', 
        error: 'Erro'
      },
      
      loading: false,
      loading_depot: false,
      client_vrt_transactions: [],
      selected_item: {},
      dialog: false,
      depots_mapped: {},
      with_comment: true,

      available: true,
      waiting_payment: true,
      done: false,
      protested: true,

      pagination: {
        page:1,
        itemsPerPage: 10,
        sortBy:['DateExpired'],
        sortDesc:[true],
        groupBy:[],
        groupDesc:[],
        mustSort:false,
        multiSort:false
      },
      total_items_count: 0,
      total_open_and_overdue: 0,
      total_ammount_sum: 0,
      loading_counters: false,
      filters: {},
    }
  },
  methods: {
    handleCloseDialog(){
      this.dialog = false
      this.selected_item = {}
    },
    getDepots(){
      this.loading_depot = true
      Api.Modality.index().then(r=> {
        r.data.map((el) => {
          this.depots_mapped[`${el.id}`] = el.name
        })
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading_depot = false
      })
    },  
    getVrts() {
      this.loading = true
      let params = this.mappedIndexParams()
      this.client_vrt_transactions = []
      Api.ClientFinancialHistoric.index({...params, client_id: this.$route.params.id}).then(r=>{
        this.client_vrt_transactions = [...r.data.data.data.map(el=>{return el.attributes})]
        this.total_items_count = r.data.total        
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    getVrtsCounter() {
      this.loading_counters = true
      Api.ClientFinancialHistoric.counter({client_id: this.$route.params.id}).then(r=>{
        this.total_open_and_overdue = r.data.total_open_and_overdue
        this.total_ammount_sum = r.data.total_ammount_sum
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading_counters = false
      })
    },
    mappedIndexParams(){
      let by_status = []
      if(this.available) by_status.push('available')
      if(this.waiting_payment) by_status.push('waiting_payment')
      if(this.done) by_status.push('done')
      if(this.protested) by_status.push('protested')
      this.filters = {
        client_id: this.$route.params.id,
        by_status: by_status,
        module: 'VrtTransactions'
      }
      
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
      let params = {
        by_status,
        page,
        limit: itemsPerPage,
        sort_field: sortBy[0]? sortBy[0] : null,
        sort_dir: sortBy[0]? (sortDesc[0]? 'desc' : 'asc') : null,
      }
      return params
    },
    shortView(){
      this.with_comment = !this.with_comment
    },
    openVrtPaymentsAssignedDialog(item){
      this.dialog = true
      this.selected_item = item
    },
    filterByStatus(status){
      this[status] = !this[status]
    },
    goToOrder(vrt_transaction){
      if(vrt_transaction?.solution == 'retail'){
        this.goToRetailPage(vrt_transaction?.external_order_id)
      }else{
        this.goToWholesaleDoneOrder(vrt_transaction?.order_id)
      }
    },  
    createProtest(item){
      this.$router.push({name:"ProtestedTransaction", params:{protested_transaction_id: item.id}})
    },
  },
  computed: {
    headers(){
      if(this.with_comment){
        return [
          { text: "Pedido", value: "order_id" },
          { text: 'Módulo', value: "place_name", sortable: false },
          { text: "Validade", value: "DateExpired" },
          { text: "Forma de Pagamento", value: "payment_description", width:"100px" },
          { text: "Comentário", value: "comment", sortable: false  },
          { text: "Pago / Total", value: "payment_ammount", sortable: false  },
          { text: "Valor restante", value: "rest", sortable: false  },
          { text: "Status", value: "processing", align: 'center' },
          { text: "Ações", value: "actions", align: 'center' },
        ]
      }else{
        return [
          { text: "Pedido", value: "order_id" },
          { text: 'Módulo', value: "place_name", sortable: false },
          { text: "Validade", value: "DateExpired" },
          { text: "Forma de Pagamento", value: "payment_description", width:"100px" },
          { text: "Pago / Total", value: "payment_ammount", sortable: false  },
          { text: "Valor restante", value: "rest", sortable: false  },
          { text: "Status", value: "processing", align: 'center' },
          { text: "Ações", value: "actions", align: 'center' },
        ]
      }
    },
    canCreate(){
      return this.isAnalyst() || this.isDirector()
    },
  },
  mounted () {
    this.getDepots();
    this.getVrtsCounter();
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        if (true) {
          this.getVrts()
        }
      },
    },
    available: {
      handler(){
        this.getVrts()
      }
    },
    waiting_payment: {
      handler(){
        this.getVrts()
      }
    },
    done: {
      handler(){
        this.getVrts()
      }
    },
    protested: {
      handler(){
        this.getVrts()
      }
    },
  },
}
</script>

<style scoped>

</style>